import React from "react";
import { motion } from "framer-motion";
import * as Phosphor from "@phosphor-icons/react";
import { reveal, container } from "../lib/motion";
import { SERVICES } from "../data/site";

const Card = ({ s }) => {
  const Icon = Phosphor[s.icon] || Phosphor.Circle;
  return (
    <motion.div
      variants={reveal}
      className="group relative flex flex-col justify-between overflow-hidden border-b border-r border-zinc-200 bg-white p-8 transition-colors duration-300 hover:bg-teal md:p-10"
      data-testid={`service-card-${s.n}`}
    >
      <div className="flex items-start justify-between">
        <Icon size={38} weight="thin" className="text-ink transition-colors duration-300 group-hover:text-white" />
        <span className="font-display text-sm font-bold tracking-widest text-zinc-300 transition-colors duration-300 group-hover:text-white/70">{s.n}</span>
      </div>
      <div className="mt-16">
        <h3 className="font-display text-xl font-semibold leading-tight tracking-tight text-ink transition-colors duration-300 group-hover:text-white md:text-2xl">
          {s.title}
        </h3>
        <p className="mt-3 font-sans text-sm leading-relaxed text-zinc-500 transition-colors duration-300 group-hover:text-white/85">
          {s.desc}
        </p>
      </div>
    </motion.div>
  );
};

export const Services = () => {
  return (
  <section id="services" className="bg-white py-24 md:py-32">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <motion.div variants={container} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-80px" }} className="mb-14 max-w-3xl">
        <motion.span variants={reveal} className="mb-6 block text-xs font-bold uppercase tracking-[0.25em] text-teal">
          Services
        </motion.span>
        <motion.h2 variants={reveal} className="font-display text-4xl font-black leading-[0.95] tracking-tight text-ink md:text-6xl" data-testid="services-headline">
          Marketing Support Built for Real Business Growth
        </motion.h2>
      </motion.div>

      <motion.div
        variants={container} initial="hidden" whileInView="show" viewport={{ once: true, margin: "-60px" }}
        className="grid border-l border-t border-zinc-200 sm:grid-cols-2 lg:grid-cols-4"
      >
        {SERVICES.map((s) => <Card key={s.n} s={s} />)}
      </motion.div>
    </div>
  </section>
  );
};
